module.exports = __webpack_public_path__ + "img/ic-download.2db7750c.svg";